exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!./assets/css/reset.css"), "");
exports.i(require("-!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!./assets/css/whhg.css"), "");

// module
exports.push([module.id, "\nbody {\n  margin: 0px;\n  width: 100%;\n}\n#headerBlank {\n  height: 11vh;\n  max-height: 80px;\n  min-height: 30px;\n}\n#app {\n  text-align: center;\n}\n.orangedBackground {\n  background-color: #ffd500;\n}\n.bluedBackground {\n  background-color: #0065B3;\n}\n.subOranged {\n  background-color: #E69200;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-35724032","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 490
// module chunks = 0